import script from "./AddressListModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressListModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddressListModal.vue?vue&type=style&index=0&id=3700d06a&lang=scss"

const __exports__ = script;

export default __exports__